// 注：apiRuledesign使用了apiBaseUrl的api域名，需手动加“ruledesign”前缀去调规则设计器的api
import { apiBaseUrl, apiOpcs } from 'yxt-biz-pc/packages/api';

// 获取规则基本信息
export const getRuleBaseInfo = (ruleCode, type) => {
  if (type === 'op') {
    return apiOpcs.get(`op/rule/base/${ruleCode}`);
  }
  return apiBaseUrl.get(`ruledesign//${ruleCode}`);
};
